import { render, staticRenderFns } from "./DistributorComparisonAmount.vue?vue&type=template&id=2e2a0c15&"
import script from "./DistributorComparisonAmount.vue?vue&type=script&lang=js&"
export * from "./DistributorComparisonAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports